// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","black":"#000000","grey":"#707070","medium-grey":"#9f9f9f","notification":"_2uAFAEKdy8cztvSALbdFvV","entered":"T6Qif9UMFSWKblgSptdo1","withIcon":"_2Nll16_WfoDU39tZtTfyyE","notificationInnerBlock":"_1TFtRf1D8Yy43SpVaxUA_q","iconWrapper":"cpvjWh4sE-1HcGw49yNYu","informativeTitle":"mY8PxdCG3LRuWKO49D7Uy","message":"_132NCU9MH_p-PGH6OQ2jcZ","additionalMsg":"_3WMKse2SV97EAOi9Ro_YME","closeButton":"Bikrb2nK4YhLyLl8zuGu9"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Notification/StandardNotification/StandardNotification.css
// module id = 1304
// module chunks = 0